<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" v-on:submit.prevent="onSubmit">
      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch
            color="success"
            v-model="formCadastro.status"
            style="width: 60px"
          >
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Nome Fantasia</span>
          <vs-input
            size="large"
            class="w-full"
            name="Nome Fantasia"
            id="Nome Fantasia"
            v-model="formCadastro.nome"
            v-validate="{ required: true, min: 6 }"
            :state="validateState(veeFields, veeErrors, 'Nome Fantasia')"
            :class="validateStateClass(veeFields, veeErrors, 'Nome Fantasia')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Razão Social</span>
          <vs-input
            size="large"
            class="w-full"
            name="Razão Social"
            id="Razão Social"
            v-model="formCadastro.razaoSocial"
            v-validate="{ required: true, min: 6 }"
            :state="validateState(veeFields, veeErrors, 'Razão Social')"
            :class="validateStateClass(veeFields, veeErrors, 'Razão Social')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>CNPJ</span>
          <vs-input
            size="large"
            class="w-full"
            name="CNPJ"
            id="CNPJ"
            v-model="formCadastro.cnpj"
            v-validate="{ required: true, min: 18 }"
            :state="validateState(veeFields, veeErrors, 'CNPJ')"
            :class="validateStateClass(veeFields, veeErrors, 'CNPJ')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            v-mask="['##.###.###/####-##']"
            icon-pack="feather"
            icon="icon-user-check"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Celular do Responsável</span>
          <vs-input
            size="large"
            class="w-full"
            name="Celular"
            id="Celular"
            v-model="formCadastro.celularResponsavel"
            v-validate="{ required: true }"
            :state="validateState(veeFields, veeErrors, 'Celular')"
            :class="validateStateClass(veeFields, veeErrors, 'Celular')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            v-mask="'(##) #####-####'"
            icon-pack="feather"
            icon="icon-smartphone"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>E-mail do Responsável</span>
          <vs-input
            type="email"
            size="large"
            class="w-full"
            name="Email"
            id="Email"
            v-model="formCadastro.emailResponsavel"
            v-validate="{ required: true, email: true }"
            :state="validateState(veeFields, veeErrors, 'Email')"
            :class="validateStateClass(veeFields, veeErrors, 'Email')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-mail"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>ISS</span>
          <vs-input
            size="large"
            class="w-full"
            name="ISS"
            id="ISS"
            type="number"
            step="0.0001"
            v-model="formCadastro.iss"
            :state="validateState(veeFields, veeErrors, 'ISS')"
            :class="validateStateClass(veeFields, veeErrors, 'ISS')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-user"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>CEP</span>
          <vs-input
            size="large"
            class="w-full"
            name="Cep"
            id="Cep"
            @keyup.native="keymonitor"
            v-model="formCadastro.cep"
            v-validate="{ required: true, min: 10 }"
            :state="validateState(veeFields, veeErrors, 'Cep')"
            :class="validateStateClass(veeFields, veeErrors, 'Cep')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            v-mask="'##.###-###'"
            icon-pack="feather"
            icon="icon-home"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Endereço</span>
          <vs-input
            size="large"
            class="w-full"
            name="Endereço"
            id="Endereço"
            v-model="formCadastro.endereco"
            v-validate="{ required: true, min: 6 }"
            :state="validateState(veeFields, veeErrors, 'Endereço')"
            :class="validateStateClass(veeFields, veeErrors, 'Endereço')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-map-pin"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Número</span>
          <vs-input
            size="large"
            class="w-full"
            name="Numero"
            id="Numero"
            v-model="formCadastro.numero"
            v-validate="{ required: true }"
            :state="validateState(veeFields, veeErrors, 'Numero')"
            :class="validateStateClass(veeFields, veeErrors, 'Numero')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-check-circle"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Complemento</span>
          <vs-input
            size="large"
            class="w-full"
            name="Complemento"
            id="Complemento"
            v-model="formCadastro.complemento"
            :state="validateState(veeFields, veeErrors, 'Complemento')"
            :class="validateStateClass(veeFields, veeErrors, 'Complemento')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-check-circle"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Bairro</span>
          <vs-input
            size="large"
            class="w-full"
            name="Bairro"
            id="Bairro"
            v-model="formCadastro.bairro"
            v-validate="{ required: true }"
            :state="validateState(veeFields, veeErrors, 'Bairro')"
            :class="validateStateClass(veeFields, veeErrors, 'Bairro')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-map-pin"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Cidade</span>
          <vs-input
            size="large"
            class="w-full"
            name="Cidade"
            id="Cidade"
            v-model="formCadastro.cidade"
            v-validate="{ required: true }"
            :state="validateState(veeFields, veeErrors, 'Cidade')"
            :class="validateStateClass(veeFields, veeErrors, 'Cidade')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-map"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Estado</span>
          <vs-input
            size="large"
            class="w-full"
            name="Estado"
            id="Estado"
            v-model="formCadastro.estado"
            v-validate="{ required: true, min: 2, max: 2 }"
            :state="validateState(veeFields, veeErrors, 'Estado')"
            :class="validateStateClass(veeFields, veeErrors, 'Estado')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-navigation"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Banco</span>
          <v-select
            :options="listBancos"
            name="Banco"
            id="Banco"
            v-model="formCadastro.banco"
            :reduce="(item) => item.id"
            v-validate="{ required: true }"
            placeholder="Selecione"
            :state="validateState(veeFields, veeErrors, 'Banco')"
            :class="validateStateClass(veeFields, veeErrors, 'Banco')"
          ></v-select>
        </div>
      </div>

      <div class="vx-col w-full mb-6">
        <label>Agência</label>
        <vs-input
          size="large"
          class="w-full"
          name="Agencia"
          id="Agencia"
          type="number"
          v-model="formCadastro.agencia"
          v-validate="'required|numeric|min_value:0'"
          :state="validateState(veeFields, veeErrors, 'Agencia')"
          :class="validateStateClass(veeFields, veeErrors, 'Agencia')"
          val-icon-danger="clear"
          danger-text="Preencha este Campo"
          icon-pack="feather"
          icon="icon-dollar-sign"
          icon-no-border
        />
      </div>

      <div class="vx-col w-full mb-6">
        <label>Conta</label>
        <vs-input
          size="large"
          class="w-full"
          name="Conta"
          id="Conta"
          type="number"
          v-model="formCadastro.conta"
          v-validate="'required|numeric|min_value:0'"
          :state="validateState(veeFields, veeErrors, 'Conta')"
          :class="validateStateClass(veeFields, veeErrors, 'Conta')"
          val-icon-danger="clear"
          danger-text="Preencha este Campo"
          icon-pack="feather"
          icon="icon-dollar-sign"
          icon-no-border
        />
      </div>

      <div class="vx-col w-full mb-6">
        <label>Digito verificador da conta</label>
        <vs-input
          size="large"
          class="w-full"
          name="Dígito verificador da conta"
          id="Dígito verificador da conta"
          type="number"
          v-model="formCadastro.digito"
          v-validate="'required|numeric|min_value:0'"
          :state="
            validateState(veeFields, veeErrors, 'Dígito verificador da conta')
          "
          :class="
            validateStateClass(
              veeFields,
              veeErrors,
              'Dígito verificador da conta',
            )
          "
          val-icon-danger="clear"
          danger-text="Preencha este Campo"
          icon-pack="feather"
          icon="icon-dollar-sign"
          icon-no-border
        />
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Chave Pix</span>
          <vs-input
            size="large"
            class="w-full"
            name="ChavePix"
            id="ChavePix"
            v-model="formCadastro.chavePix"
            :state="validateState(veeFields, veeErrors, 'ChavePix')"
            :class="validateStateClass(veeFields, veeErrors, 'ChavePix')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-navigation"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Optante pelo simples nacional?</span>
          <v-select
            :options="opcoesSimNao"
            name="Optante pelo simples nacional"
            label="label"
            id="Optante pelo simples nacional"
            v-model="formCadastro.simples"
            class="select-large w-full"
            :reduce="(item) => item.id"
            v-validate="{ required: true }"
            :state="
              validateState(
                veeFields,
                veeErrors,
                'Optante pelo simples nacional',
              )
            "
            :class="
              validateStateClass(
                veeFields,
                veeErrors,
                'Optante pelo simples nacional',
              )
            "
          ></v-select>
        </div>
      </div>

      <div class="vx-col w-full mb-6">
        <label>% Corretagem</label>
        <vs-input
          size="large"
          class="w-full"
          name="Corretagem"
          id="Corretagem"
          type="number"
          v-model="formCadastro.corretagem"
          v-validate="'required|numeric|min_value:0|max_value:100'"
          :state="validateState(veeFields, veeErrors, 'Corretagem')"
          :class="validateStateClass(veeFields, veeErrors, 'Corretagem')"
          val-icon-danger="clear"
          danger-text="Preencha este Campo"
          v-mask="'###'"
          icon-pack="feather"
          icon="icon-percent"
          icon-no-border
        />
      </div>

      <ErrorsAlert :errors="errors" />

      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            v-on:click.stop.prevent="onReset"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :edit="dados && dados.id == null ? false : true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import * as lang from 'vuejs-datepicker/src/locale';
import vSelect from 'vue-select';
import service from '../../services';
import BotaoSubmit from '../../components/BotaoSubmit';
import functions from '../../utils/functions';
import notify from '../../utils/notify';
import utilsList from '../../utils/list';
import ErrorsAlert from '../../components/ErrorsAlert';
import cpfCnpj from '../../services/cpfCnpj';
import { OPCOES_SIM_NAO } from '../../utils/constants';

export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
  },
  watch: {
    dados() {
      this.preencheForm();
    },
  },
  computed: {
    errors() {
      return this.$validator.errors.all();
    },
  },
  data() {
    return {
      validateState: utilsList.validateState,
      validateStateClass: utilsList.validateStateClass,
      aguardeCadastro: false,
      idEmpresa: null,
      estados: [],
      cidades: [],
      languages: lang,
      opcoesSimNao: OPCOES_SIM_NAO,
      estado: null,
      funcoesValicao: null,
      carteiras: [],
      listBancos: [],
      formCadastro: {
        id: null,
        idEmpresa: null,
        status: true,
        nome: '',
        razaoSocial: '',
        cep: '',
        endereco: '',
        bairro: '',
        numero: '',
        complemento: '',
        cidade: '',
        estado: '',
        cnpj: '',
        celularResponsavel: '',
        emailResponsavel: '',
        iss: null,
        banco: null,
        agencia: null,
        conta: null,
        digito: null,
        chavePix: null,
        simples: null,
        corretagem: null,
      },
    };
  },
  methods: {
    preencheForm() {
      if (this.dados && this.dados.id) {
        this.formCadastro.id = this.dados.id;
        this.formCadastro.status = this.dados.deletedAt == null ? true : false;
        this.formCadastro.nome = this.dados.nome;
        this.formCadastro.razaoSocial = this.dados.razaoSocial;
        this.formCadastro.cep = this.dados.cep;
        this.formCadastro.endereco = this.dados.endereco;
        this.formCadastro.bairro = this.dados.bairro;
        this.formCadastro.numero = this.dados.numero;
        this.formCadastro.complemento = this.dados.complemento;
        this.formCadastro.cidade = this.dados.cidade;
        this.formCadastro.estado = this.dados.estado;
        this.formCadastro.cnpj = this.dados.cnpj;
        this.formCadastro.celularResponsavel = this.dados.celularResponsavel;
        this.formCadastro.emailResponsavel = this.dados.emailResponsavel;
        this.formCadastro.iss = this.dados.iss;
        this.formCadastro.banco = this.dados.banco;
        this.formCadastro.agencia = this.dados.agencia;
        this.formCadastro.conta = this.dados.conta;
        this.formCadastro.digito = this.dados.digito;
        this.formCadastro.chavePix = this.dados.chavePix;
        this.formCadastro.simples = this.dados.simples;
        this.formCadastro.corretagem = this.dados.corretagem;
      } else {
        this.resetForm();
      }
    },
    onSubmit() {
      if (!this.formCadastro.cnpj) {
        notify.notifyFail(this.$vs, 'CPF OU CNPJ Inválido');
        return;
      }

      const validado = cpfCnpj.valida_cpf_cnpj(this.formCadastro.cnpj);
      if (!validado) {
        notify.notifyFail(this.$vs, 'CPF OU CNPJ Inválido');
        return;
      }
      this.formCadastro.idEmpresa = this.idEmpresa;

      var action = 'Atualizar';
      var msgRetorno = 'Dados Atualizados com sucesso';
      if (!this.formCadastro.id) {
        action = 'Adicionar';
        msgRetorno = 'Registro Adicionado com sucesso';
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          service
            .post('Convenio', action, this.formCadastro)
            .then(() => {
              this.aguardeCadastro = false;
              notify.notifySuccess(this.$vs, msgRetorno);
              this.$emit('concluido', true);
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              notify.notifyFail(this.$vs, error);
            });
        }
      });
    },
    resetForm() {
      this.formCadastro = {
        id: null,
        idEmpresa: null,
        status: true,
        nome: '',
        razaoSocial: '',
        cep: '',
        endereco: '',
        bairro: '',
        numero: '',
        complemento: '',
        cidade: '',
        estado: '',
        cnpj: '',
        celularResponsavel: '',
        emailResponsavel: '',
        iss: null,
        banco: null,
        agencia: null,
        conta: null,
        digito: null,
        chavePix: null,
        simples: null,
        corretagem: null,
      };
    },
    onReset(evt) {
      if (this.sideBar == true) {
        this.$emit('cancel');
      } else {
        evt.preventDefault();
        this.resetForm();
        this.$nextTick(() => {
          this.show = true;
        });
      }
    },
    keymonitor: async function () {
      if (this.formCadastro.cep.length == 10) {
        this.$vs.loading();
        var cepbusca = this.formCadastro.cep.replace('.', '').replace('-', '');

        try {
          const { data } = await service.post('g', 'BuscaCEP', {
            cep: cepbusca,
          });

          this.$set(this.formCadastro, 'endereco', data.street);
          this.$set(this.formCadastro, 'bairro', data.neighborhood);
          this.$set(this.formCadastro, 'cidade', data.city);
          this.$set(this.formCadastro, 'estado', data.state);
        } catch (error) {
          this.$set(this.formCadastro, 'endereco', null);
          this.$set(this.formCadastro, 'bairro', null);
          this.$set(this.formCadastro, 'cidade', null);
          this.$set(this.formCadastro, 'estado', null);

          notify.notifyFail(this.$vs, 'Não Foi possível encontrar o cep');
        } finally {
          this.$vs.loading.close();
        }
      }
    },
    async getDominios() {
      try {
        const Promises = [
          functions.buscaDadosSelects(
            'domBancos',
            this.listBancos,
            'LongName',
            'idBanco',
          ),
        ];

        await Promise.all(Promises);

        this.listBancos = this.listBancos.sort((a, b) => {
          const COMPE_A = a.label.split(' - ')[0];
          const COMPE_B = b.label.split(' - ')[0];

          return +COMPE_A - +COMPE_B;
        });
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      }
    },
  },
  async mounted() {
    this.getDominios();
    this.$forceUpdate();
  },
  components: {
    BotaoSubmit,
    'v-select': vSelect,
    ErrorsAlert,
  },
};
</script>
<!------------ END SCRIPT ------------>
